import { Divider, Typography } from "antd";
import { partnerTermsMetadata, partnerTermsSections } from "./partnerTermsContent";
import "./terms.css";

const { Title, Paragraph, Text } = Typography;

export const PartnerTermsPage = () => {
  return (
    <div className="terms-page">
      <div className="terms-card">
        <Title level={2}>OneGrad Partner Terms</Title>
        <Text type="secondary">
          Effective Date: {partnerTermsMetadata.effectiveDateDisplay} • Version:{" "}
          {partnerTermsMetadata.policyVersion}
        </Text>
        <Paragraph className="terms-disclaimer">
          Draft – not legal advice. This document is a placeholder and must be
          reviewed by legal counsel before use.
        </Paragraph>

        <Divider />

        {partnerTermsSections.map((section) => (
          <section key={section.title}>
            <Title level={4}>{section.title}</Title>
            <Paragraph>{section.body}</Paragraph>
          </section>
        ))}
      </div>
    </div>
  );
};
